import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";

import './style.css';

import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate, useParams } from 'react-router-dom';
import { fetchClientService, updateClientService, deleteClientService } from "../../../../features/client/service/client-service";
import { fetchPlansService } from "../../../../features/plans/service/plan-service";
import clientData from "../../../../features/client/forms/client-data";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import InfoComponent from "../../../../components/info/info";
import { CustomModal, useModal } from "../../../../components/modals/common/index";
import { Typography } from "@mui/material";

export function EditClient() {
    const { id } = useParams();
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();
    
    // Hook para controlar o estado da modal de confirmação de exclusão
    const deleteModal = useModal();

    const handleEditPlan = async (formData: any) => {
        formData.isUnlimited = false;

        if(formData.price) {
            formData.price = Math.round(Number(formData.price) * 100);
        }

        formData.payed = false;
        
        if(id && formData) {
          const response = await updateClientService(id, formData);

          if(response) {
            showAlert('Cliente editado com sucesso', SEVERITY.SUCCESS);
            navigate('/clientes');
          }
        }
    };
    
    // Função para lidar com a exclusão do cliente
    const handleDeleteClient = async () => {
        if (id) {
            try {
                await deleteClientService(id);
                showAlert('Cliente excluído com sucesso', SEVERITY.SUCCESS);
                navigate('/clientes');
            } catch (error) {
                console.error('Erro ao excluir cliente:', error);
                showAlert('Erro ao excluir cliente', SEVERITY.ERROR);
            }
        }
    };

    const fetchPlansData = useCallback(async () => {
        try {
            const planTypes = await fetchPlansService();
            const planTypesOptions = planTypes?.map(({ name, id}: any) => ({ label: name, value: id }));

            setFormData(clientData(undefined, undefined, planTypesOptions));
        } catch (error) {
            console.log(error);
        }
    }, []);

    const fetchClientData = useCallback(async (id: string) => { 
        try {
            const [response, plans] = await Promise.all([
                fetchClientService(id),
                fetchPlansService()
            ]);
            const plansOptions = plans?.map(({ name, id}: any) => ({ label: name, value: id }));

            const data = clientData(id, response, plansOptions);
            setFormData(data);
        } catch (error) {
            console.log(error);
        }
    }, []); 

    useEffect(() => {
        if (id) fetchClientData(id);
        fetchPlansData();
    }, [fetchClientData, fetchPlansData, id]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Clientes', 'Editar cliente']} href={['/clientes', '']} onNavigate={navigate} />
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleEditPlan}
                            onCancel={() => navigate('/clientes', {replace: true})}
                            title={`Editar cliente`}
                            showDeleteIcon={true}
                            onClickedMenuContextType={(type: string) => {
                                // Verifica se o tipo clicado é 'delete' e abre a modal
                                if (type === 'delete') {
                                    deleteModal.openModal();
                                }
                            }}
                        />
                    </>
                )}
                
                {/* Modal de confirmação de exclusão */}
                <CustomModal
                    open={deleteModal.isOpen}
                    onClose={deleteModal.closeModal}
                    title="Confirmar exclusão"
                    content={
                        <Typography>
                            Tem certeza que deseja excluir este cliente? Esta ação não pode ser desfeita.
                        </Typography>
                    }
                    buttons={[
                        {
                            id: 'cancel',
                            label: 'Cancelar',
                            variant: 'outlined',
                            color: 'primary',
                            onClick: deleteModal.closeModal
                        },
                        {
                            id: 'confirm',
                            label: 'Excluir',
                            variant: 'contained',
                            color: 'error',
                            onClick: () => {
                                handleDeleteClient();
                                deleteModal.closeModal();
                            }
                        }
                    ]}
                />
            </div>
        </div>
    );
}
